; (() => {
  function flipbook() {
    this.wrapper = document.querySelector(".customFlipBookSection");
    this.section = this.wrapper.closest(".shopify-section");
    this.scrollLeftBtn = this.section.querySelector("[data-scroll-left]");
    this.scrollRightBtn = this.section.querySelector("[data-scroll-right]");
    this.nextBtn = this.wrapper.querySelector(".nextFlipBtn");
    this.prevBtn = this.wrapper.querySelector(".prevFlipBtn");
    this.wishlistBtns = this.wrapper.querySelectorAll(".bookLinkItem");
    this.url = this.wrapper.getAttribute("data-app-url");


    this.form = this.wrapper.querySelector("[data-form]");
    this.emailField = this.form.querySelector("[data-email-field]");
    this.phoneField = this.form.querySelector("[data-phone-field]");
    this.submitButton = this.form.querySelector("[data-submit]");

    this.formOverlays = this.wrapper.querySelectorAll("hideoverlay");


    this.data = JSON.parse(localStorage.getItem("wishlist-items")) || {
      theme:'Drop-8',
      items: [],
      form: {
        email: "",
        phone: "",
      }
    }
    this.wishlistChanged = false
    this.phoneInput = window.intlTelInput(this.phoneField, {
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
    });

    this.init()
  }
  flipbook.prototype = Object.assign(flipbook.prototype, {
    validateData: function () {
      if(!this.data.theme || this.data.theme != 'Drop-8'){
        this.data.theme = 'Drop-8'
        this.data.items = []
        this.data.form = {
          email: "",
          phone: "",
        }
      }
      if (!this.data.items) {
        this.data.items = [];
      }
      if (!this.data.form) {
        this.data.form = {
          email: "",
          phone: "",
        }
      }
      this.syncLocalStorage()
    },
    init: function () {
      this.validateData()
      this.initFlipBook()
      this.handleListeners()

      this.syncWishlistBtns(true)
      this.syncForm()
      this.fetchLikes()
      this.toggleCoverPages()
      this.wishlistSubscription = setInterval(() => {
        if (this.wishlistChanged) {
          this.postWishlist()
          this.wishlistChanged = false
        }
      }, 1000);
    },
    postWishlist: function () {
      fetch(this.url + '/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.data),
      })
    },
    initFlipBook: function () {
      this.pageFlip = new St.PageFlip(
        document.querySelector("[data-book-container]"),
        {
          width: 1300, // base page width
          height: 1674, // base page height
          size: "stretch",
          // set threshold values:
          minWidth: 250,
          maxWidth: 1200,
          autoSize: true,
          minHeight: 500,
          maxHeight: 1800,
          drawShadow: true,
          maxShadowOpacity: 0.5, // Half shadow intensity
          showCover: false,
          disableFlipByClick: true,
          clickEventForward: true,
          mobileScrollSupport: false
        }
      );

      // load pages
      this.pageFlip.loadFromHTML(this.wrapper.querySelectorAll(".page"));
      this.section.scrollTo({
        left: (50 * (this.section.scrollWidth - this.section.clientWidth)) / 100,
        behavior: 'smooth',
      })
    },
    syncForm: function () {
      if (this.data.form.email === "" && this.data.form.phone === "") {
        this.submitButton.style.display = 'block';
      } else {

        this.submitButton.style.display = 'none';
        // Remove each element from the document
        document.querySelectorAll('hideOverlay').forEach(element => {
          element.style.display = 'none';
        });
        this.nextBtn.classList.remove("disbaledBtn");
        document.getElementById("formMessage").innerText = "Your Form Submission was Successful!";

        this.emailField.value = this.data.form.email;
        this.phoneInput.setNumber(this.data.form.phone);
      }
    },
    preventNextonFormPage: function () {
      const pageWithForms = this.wrapper.querySelectorAll(".page[data-has-form]");
      const hasVisibleForm = Array.from(pageWithForms).filter(page => page.style.display !== "none");
      const visibleForm = hasVisibleForm?.[0] || null;
      const hasData = this.data.form.email !== "" || this.data.form.phone !== "";

      if (visibleForm && !hasData) {
        this.nextBtn.classList.add("disbaledBtn");
        document.querySelectorAll('hideOverlay').forEach(element => {
          element.style.display = 'block';
        });
      } else {
        this.nextBtn.classList.remove("disbaledBtn");
        document.querySelectorAll('hideOverlay').forEach(element => {
          element.style.display = 'none';
        });
      }

    },
    syncWishlistBtns: function (isFirstTime = false) {
      this.wishlistBtns.forEach(btn => {
        const id = btn.getAttribute("data-productId");
        this.syncWishlistBtn(btn, id, isFirstTime);
      });
    },
    syncWishlistBtn: function (btn, id, isFirstTime) {
      if (this.data.items.findIndex(item => item.variantId == id) !== -1) {
        btn.classList.add("added");
        this.incrementLike(id, isFirstTime);
      } else {
        this.decrementLike(id);
        btn.classList.remove("added");
      }
    },
    syncLocalStorage: function () {
      localStorage.setItem("wishlist-items", JSON.stringify({ ...this.data }));
    },
    handleListeners: function () {
      this.prevBtn.addEventListener("click", this.onFlipPrev.bind(this));
      this.nextBtn.addEventListener("click", this.onFlipNext.bind(this));

      this.pageFlip.on("flip", this.onFlip.bind(this));
      this.pageFlip.on("changeState", this.onStateChange.bind(this));

      this.wishlistBtns.forEach(btn => {
        btn.addEventListener("click", this.onWishlist.bind(this));
      });

      window.addEventListener('resize', this.onResize.bind(this));

      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.emailField.addEventListener('input', this.onFormInput.bind(this));
      this.phoneField.addEventListener('input', this.onFormInput.bind(this));

      this.formOverlays.forEach(overlay => {
        overlay.addEventListener('click', this.onFormOverlayClick.bind(this));
      })
      this.scrollLeftBtn.addEventListener('click', this.onScrollLeft.bind(this));
      this.scrollRightBtn.addEventListener('click', this.onScrollRight.bind(this));
    },
    onScrollLeft: function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.section.scrollTo({
        left: 0,
        behavior: 'smooth',
      })
      return false;
    },
    onScrollRight: function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.section.scrollTo({
        left: (100 * (this.section.scrollWidth - this.section.clientWidth)) / 100,
        behavior: 'smooth',
      })
      return false;
    },
    onFormOverlayClick: function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.section.scrollTo({
        left: (100 * (this.section.scrollWidth - this.section.clientWidth)) / 100,
        behavior: 'smooth',
      })
      alert("Please fill the form to continue");
      return false;
    },
    onFlipPrev: function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.pageFlip.flipPrev('middle');
      return false;
    },
    onFlipNext: function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.pageFlip.flipNext('middle');
      return false;
    },
    onFlip: function (e) {
      let pageFlip = this.pageFlip;

      if (e.data == 0 || e.data == pageFlip.getPageCount() - 2) {
        this.section.scrollTo({
          left: (50 * (this.section.scrollWidth - this.section.clientWidth)) / 100,
          behavior: 'smooth',
        })
      } else if (this.blockingPageFlip) {
        this.section.scrollTo({
          left: (100 * (this.section.scrollWidth - this.section.clientWidth)) / 100,
          behavior: 'smooth',
        })
      }
      else {
        this.section.scrollTo({
          left: 0,
          behavior: 'smooth',
        });
      }
      this.blockingPageFlip = false;


      if (this.data.form.email === "" && this.data.form.phone === "" && e.data > 7) {
        setTimeout(() => {
          this.blockingPageFlip = true;
          pageFlip.flip(7, 'middle')
          alert("Please fill the form to continue");
        }, 500)
        return
      }
      const pages = this.wrapper.querySelector('.stf__block').querySelectorAll('.page')
      const currentPage = pages[e.data];
      const nextPage = pages?.[e.data + 1];


      Array.from(this.wrapper.querySelector('.stf__block').querySelectorAll('.page')).forEach(page => {
        page.classList.remove("activePage");
        page.classList.remove("nextPage");
      })
      currentPage.classList.add("activePage");
      if (nextPage) {
        nextPage.classList.add("nextPage");
      }

      if (e.data == 0) {
        document.querySelector(".flipBookContainer").classList.add("notOpen");
      }
      else {
        document.querySelector(".flipBookContainer").classList.remove("notOpen");
      }
      this.preventNextonFormPage(e.data)
      this.section.scrollTo({
        left: (50 * (this.section.scrollWidth - this.section.clientWidth)) / 100,
        behavior: 'smooth',
      })
    },
    onStateChange: function (e) {
      if (e.data == "user_fold" || e.data == "flipping") {
        document.querySelector(".flipBookContainer").classList.add("changingState");
        this.nextBtn.classList.add("tempDisabled");
        this.prevBtn.classList.add("tempDisabled");
        document.querySelector(".flipBookContainer").classList.remove("notOpen");
      }
      if (e.data == "read") {
        document.querySelector(".flipBookContainer").classList.remove("changingState");
        this.nextBtn.classList.remove("tempDisabled");
        this.prevBtn.classList.remove("tempDisabled");
      }
    },
    onWishlist: function (e) {
      const btn = e.currentTarget;
      const data = JSON.parse(btn.querySelector('[data-product]').innerHTML)
      this.toggleWishlistItem(btn, data);
    },
    onResize: function (e) {
      this.toggleCoverPages();
    },
    onFormSubmit: function (e) {
      e.preventDefault();
      if (!this.phoneInput.isValidNumber() || !this.phoneInput.isPossibleNumber()) {
        this.phoneField.closest('fieldset').classList.add("error");
        this.phoneField.focus();
        return
      }
      if (this.emailField.value.trim() === "") {
        this.emailField.closest('fieldset').classList.add("error");
        this.emailField.focus();
        return
      }
      const formData = {
        email: this.emailField.value.trim(),
        phone: this.phoneInput.getNumber()
      };
      this.data.form = formData;
      this.syncForm();
      this.syncLocalStorage();
    },
    onFormInput: function (e) {
      e.target.closest('fieldset').classList.remove("error");
    },
    toggleWishlistItem: function (btn, newItem) {
      const index = this.data.items.findIndex(item => item.variantId === newItem.variantId);
      if (index === -1) {
        this.data.items.push(newItem);
      } else {
        this.data.items.splice(index, 1);
      }
      this.wishlistChanged = true;
      this.syncWishlistBtn(btn, newItem.variantId);
      this.syncLocalStorage();
    },
    fetchLikes: function () {
      fetch(this.url + '/likes', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(response => response.json())
        .then(data => {
          Object.keys(data).forEach(item => {
            this.setLikes(item, data[item])
          })
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
    setLikes: function (item, count = 0) {
      const likesSpan = this.wrapper.querySelector(`#likes-${item}`);
      if(likesSpan)
        likesSpan.innerText = Math.floor(count);
    },
    incrementLike: function (id, isFirstTime) {
      const likesSpan = this.wrapper.querySelector(`#likes-${id}`);
      let likesCount = parseInt(likesSpan.innerText, 10);
      if (isFirstTime && likesCount === 0) {
        likesCount = 1;
        likesSpan.innerText = likesCount;
      } else if (!isFirstTime) {
        likesCount++;
        likesSpan.innerText = likesCount;
      }
    },
    decrementLike: function (id) {
      const likesSpan = this.wrapper.querySelector(`#likes-${id}`);
      let likesCount = parseInt(likesSpan.innerText, 10);
      if (likesCount > 0) {
        likesCount--;
        likesSpan.innerText = likesCount;
      }
    },
    toggleCoverPages: function () {

    }

  });
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector(".customFlipBookSection"))
      new flipbook();
  })
})();

